import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { MdOutlineAddPhotoAlternate } from 'react-icons/md';
import { FaPhotoVideo } from 'react-icons/fa';
import { ActionButton, Folder, UploadMenu, EmptyContent } from '../../components';
import s from './style.css';
import { vault } from '../../actions';
import FileView from '../FileView';
import { isCloseToBottom } from '../../utils';
import ContextMenu from '../../components/ContextMenu';
let loadingMore = false;
const PhotosScreen = (props) => {
    useEffect(() => {
        if (!props.fetched)
            props.fetchPhotos(props.url, 'recents', true, true);
    }, []);
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [props.url]);
    const handleScroll = () => {
        if (isCloseToBottom() && !loadingMore && props.url) {
            loadingMore = true;
            props.fetchPhotos(props.url, 'recents', false, false, () => (loadingMore = false));
        }
    };
    const [highlighted, setHighlighted] = useState(null);
    const handlePhotoChange = async (e) => {
        e.preventDefault();
        if (e.target.files) {
            props.uploadFiles(Array.from(e.target.files), props.isBasic, null, true);
        }
    };
    const [contextMenuVisible, setContextMenuVisible] = useState(false);
    const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 });
    const [contextItem, setContextItem] = useState(null);
    const handleMenuItemClick = () => {
        setContextMenuVisible(false);
    };
    const handleCloseContextMenu = () => {
        setContextMenuVisible(false);
    };
    const handleContextMenu = (e, item) => {
        e.preventDefault();
        if (item.folderType === 'camera_uploads')
            return;
        setContextMenuVisible(true);
        setContextMenuPosition({ x: e.pageX + 10, y: e.pageY });
        setContextItem(item);
    };
    const handleEmptyClick = () => {
        setHighlighted(null);
        setContextMenuVisible(false);
    };
    return (React.createElement("div", { className: s.main, id: 'main', onClick: handleEmptyClick, role: 'button', tabIndex: 0, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ')
                handleEmptyClick();
        } },
        contextMenuVisible && (React.createElement(ContextMenu, { x: contextMenuPosition.x, y: contextMenuPosition.y, onItemClick: handleMenuItemClick, item: contextItem, type: 'file', inFileView: true })),
        React.createElement(UploadMenu, null),
        React.createElement(FileView, null),
        React.createElement("div", { className: s.screenContainer },
            React.createElement("div", { className: s.stackContainer },
                React.createElement("div", { className: s.stackItem },
                    React.createElement("button", { type: 'button', className: s.stackItemTitle }, "Photos"))),
            React.createElement("div", { style: { flexDirection: 'row', display: 'flex' } },
                React.createElement(ActionButton, { htmlFor: 'upload', text: 'Upload photos', icon: React.createElement(MdOutlineAddPhotoAlternate, { fontSize: 20 }) })),
            React.createElement("input", { type: 'file', accept: 'image/*', multiple: true, id: 'upload', style: { display: 'none' }, onChange: handlePhotoChange }),
            props.photos.length > 0 ? (React.createElement("div", { style: { display: 'flex', flexDirection: 'row', flexWrap: 'wrap' } }, props.photos.map((item, index) => (React.createElement(Folder, { item: item, index: index, key: `${item.name}${index}`, highlighted: highlighted, setHighlighted: (id) => setHighlighted(id), handleContextMenu: (e) => handleContextMenu(e, item) }))))) : (React.createElement(EmptyContent, { icon: React.createElement(FaPhotoVideo, { size: 100, color: 'lightgrey' }), text: "Your memory vault is empty, but it won't be for long. Begin by adding your first photo.", action: React.createElement(ActionButton, { htmlFor: 'upload', text: 'Upload photos', icon: React.createElement(MdOutlineAddPhotoAlternate, { fontSize: 20 }), style: { alignSelf: 'center', marginBottom: 20 } }) })))));
};
const mapStateToProps = (state) => {
    const currentAlbum = state.appTemp.albumStack[state.appTemp.albumStack.length - 1];
    let lastAlbumName = state.appTemp.albumStack.length === 1
        ? 'home'
        : state.appTemp.albumStack[state.appTemp.albumStack.length - 2].name;
    if (lastAlbumName === 'home')
        lastAlbumName = 'Albums';
    return {
        photos: Object.values(state.photos[currentAlbum.id] || {}),
        fetched: state.fetched.vaultAlbums.recents,
        currentAlbum,
        lastAlbumName,
        albums: Object.values(state.vaultAlbums),
        atHome: state.appTemp.albumStack.length === 1,
        url: state.url.photosUrls[currentAlbum.id],
        isBasic: state.auth.user?.subscription === 'basic',
    };
};
const connector = connect(mapStateToProps, { ...vault });
export default connector(PhotosScreen);
